import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Press } from '@dorixona/ui'
import { Icon } from '../../../ui/Icon'
import { useSelection } from '../selection'

/**
 * Поле поиска каталога, когда включён мультипоиск: выглядит как поле, а
 * нажатие открывает поиск на весь экран. Если лекарства уже выбраны — справа
 * их число: выбор не потерялся, к нему можно вернуться.
 */
export function SearchEntry() {
  const { t } = useTranslation('catalog')
  const navigate = useNavigate()
  const { items } = useSelection()
  return (
    <Press
      squish="row"
      className="search ms-entry"
      aria-label={
        items.length > 0
          ? `${t('catalog:searchShort')}. ${t('catalog:multiSearch.selectedCount', { count: items.length })}`
          : t('catalog:searchShort')
      }
      onPress={() => {
        void navigate('/search')
      }}
    >
      <Icon name="i-search" size={19} />
      <span className="ms-entry-text">{t('catalog:searchShort')}</span>
      {items.length > 0 ? (
        <span className="ms-count num" aria-hidden="true">
          {items.length}
        </span>
      ) : null}
    </Press>
  )
}
